module.exports = __webpack_public_path__ + "assets/1e41b2388f14cdeb1d75e779cdc28168.png";